import type { GenieIconName } from "@/components/ui/genie-icons/genie-icons";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

interface ReviewSectionCardProps {
  title: string;
  subtitle?: string;
  genieIcon: GenieIconName;
  children: React.ReactNode;
  brand?: string;
  categoryColor?: string;
}

export const ReviewSectionCard = ({
  title,
  subtitle,
  genieIcon,
  children,
  brand = '#4E9CFF',
  categoryColor,
}: ReviewSectionCardProps) => {
  const headerColor = categoryColor || brand;

  return (
    <div className="p-[1.5px] rounded-xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]">
      <div className="rounded-[inherit] bg-white overflow-hidden">
        {/* Header */}
        <div
          className="px-6 py-5 border-b flex items-center justify-between"
          style={{ background: `${headerColor}05`, borderColor: `${headerColor}15` }}
        >
          <div className="flex items-center gap-3">
            <div className="hidden sm:block">
              <GenieIcon
                name={genieIcon}
                size={28}
                color={brand}
                secondaryColor="#FF4DB8"
                gradientEnabled={true}
                gradientAngle={135}
                label={title}
              />
            </div>
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900">{title}</h3>
              {subtitle && <p className="text-xs sm:text-sm text-gray-600 mt-0.5">{subtitle}</p>}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 py-6">{children}</div>
      </div>
    </div>
  );
};
